import './App.css';

function App() {
  return (
    <div className='hourglass'>
      <div className='frame'>
        <div className='top'></div>
        <div className='bottom'>
          <div className='drip'></div>
          <div className='glass'></div>
        </div>
      </div>
    </div>
  );
}

export default App;
